import { breakpoints } from "@gigpro/ui/utils/useBreakpoint";
import { getHireJobsListInfiniteQueryOptions, getNextPageParam, getPreviousPageParam } from "@sidegigllc/api/client";
import { AVAILABILITY_MINE, AVAILABILITY_OFF } from "domains/hire/components/HiringScheduleFilters/constants";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { availability?: string };

// Desktop with a sentinel availability only needs the jobs once the filters open, which loaders can't know.
export const openJobsQuery = ({ availability = AVAILABILITY_MINE }: QueriesInput) => {
  const isSentinel = availability === AVAILABILITY_OFF || availability === AVAILABILITY_MINE;
  return getHireJobsListInfiniteQueryOptions(
    { ordering: "-created_ts", status: "open", page_size: 200 },
    {
      query: {
        getNextPageParam,
        getPreviousPageParam,
        enabled: !isSentinel || !globalThis.matchMedia(`(min-width: ${breakpoints.md}px)`).matches,
      },
    },
  );
};

export const queries = (input: QueriesInput): Array<WarmableQuery> => [openJobsQuery(input)];
